import { createUserAgentParser } from '@lib/user-agent-parser';
export const isMobile = () => {
  const { getDevice } = createUserAgentParser();

  const deviceType = getDevice().type;

  return deviceType === 'mobile';
};
